import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useGetUser } from "../../../hooks/useGetUser";
import { useHandleDismissAlert } from "../../../hooks/useHandleGlobalAlert";
import {
  useAddPaymentPreferencesMutation,
  useGetPaymentPreferencesQuery
} from "../../../lib/api/endpoints/settings/settingsEndpoints";
import { isLayoutTall } from "../../../lib/redux/slices/layoutSlice";
import { handleAPIRequests } from "../../../utils/handleAPIRequests";
import G_GlobalAlert from "./GlobalAlert";

/**
 * @since February 2024
 * @author Issa Jean Marie <jeanmarieissa@gmail.com>
 * @see {@link https://issadevs.com} - Author's website
 * @returns {JSX.Element | null}
 */

const ResumeMoMo = (): JSX.Element | null => {
  const {
    isFetching,
    data: paymentPreferences,
    refetch
  } = useGetPaymentPreferencesQuery("");

  const dispatch = useDispatch();
  const { areAlertsPaused } = useHandleDismissAlert();

  const [haltMoMo, { isLoading: isHalting }] =
    useAddPaymentPreferencesMutation();

  const haltMomoPayment = paymentPreferences?.payload?.haltMomoPayment;

  const handleHaltMoMo = () => {
    handleAPIRequests({
      request: haltMoMo,
      halt: false
    });
  };

  const handleReload = () => {
    refetch();
  };

  useEffect(() => {
    if (areAlertsPaused) {
      dispatch(isLayoutTall(true));
      return;
    } else {
      if (haltMomoPayment) {
        dispatch(isLayoutTall(false));
      } else {
        dispatch(isLayoutTall(true));
      }
    }
  }, [areAlertsPaused, dispatch, haltMomoPayment]);

  const { canUser } = useGetUser();
  const canUserPause = canUser(["PAUSE_MOMO_PAYMENTS"]);

  return haltMomoPayment ? (
    <G_GlobalAlert
      title="MoMo payment paused"
      action={canUserPause ? handleHaltMoMo : handleReload}
      actionLabel={canUserPause ? "Resume" : "Reload"}
      isLoading={isHalting || isFetching}
    />
  ) : null;
};

export default ResumeMoMo;
